import axios from 'axios'

// 动态获取 API 基础路径
// 优先使用环境变量，如果未定义则根据当前环境自动判断
const getBaseURL = () => {
  if (process.env.VUE_APP_API_BASE_URL) {
    return process.env.VUE_APP_API_BASE_URL
  }
  
  // 在本地开发环境（devServer proxy 启用时），我们应该使用相对路径 '/api'
  // 这样请求会被发送到 http://localhost:8080/api，然后被代理转发到 http://localhost:8003/api
  // 从而避免跨域问题
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  return isLocalhost ? '/api' : '/api'
}

const service = axios.create({
  baseURL: getBaseURL(),
  withCredentials: true,
  timeout: 10000,
  xsrfCookieName: 'autosquare_geofusion_csrf',
  xsrfHeaderName: 'X-CSRFToken'
})

// 请求拦截器
// 响应拦截器
service.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.error('API 请求错误:', error)
    return Promise.reject(error)
  }
)

export default service
